export default __webpack_public_path__ + "src/assets/sign-message.28ffc3ae4954268ad291bd411ad66065.svg";